import StepChannels from './steps/StepChannels';
import StepInstagram from './steps/StepInstagram';
import StepWhatsApp from './steps/StepWhatsApp';
import StepOrders from './steps/StepOrders';
import StepStore from './steps/StepStore';
import StepKnowledge from './steps/StepKnowledge';
import StepDesign from './steps/StepDesign';
import StepNotifications from './steps/StepNotifications';
import StepTest from './steps/StepTest';
import StepPlan from './steps/StepPlan';

// Register a component here only when a flow introduces a genuinely new step.
// App IDs, branding, step order and supported versions come from the backend's
// versioned flow definition, not from app-specific routing conditions.
export const WIX_STEP_COMPONENTS = Object.freeze({
  orders: StepOrders,
  store: StepStore,
  instagram: StepInstagram, whatsapp: StepWhatsApp, channels: StepChannels, knowledge: StepKnowledge,
  design: StepDesign, notifications: StepNotifications, test: StepTest, plan: StepPlan,
});

// Steps only the Wix apps' onboarding (pages/wix-apps/WixAppOnboarding.js) renders, in the main Wix onboarding's look:
// "website" = the one-click "also on your website" question of apps that do not add the widget on completion.
export const WIX_APP_ONLY_STEPS = Object.freeze(['website']);
const KNOWN_STEPS = new Set([...Object.keys(WIX_STEP_COMPONENTS), ...WIX_APP_ONLY_STEPS]);

export function resolveWixFlow(state) {
  const flow = state?.onboarding;
  if (!flow || flow.key !== state.flow_key || flow.version !== state.flow_version
      || !Number.isInteger(flow.version) || flow.version < 1 || flow.mode !== 'guided'
      || !Array.isArray(flow.steps) || !flow.steps.length
      || new Set(flow.steps).size !== flow.steps.length
      || !flow.steps.every(step => KNOWN_STEPS.has(step))
      || !['default', 'instagram', 'whatsapp'].includes(flow.chat_appearance)
      || typeof flow.title !== 'string' || !flow.title.trim()
      || typeof flow.default_agent_name !== 'string' || !flow.default_agent_name.trim()) return null;
  return flow;
}
